import * as React from "react";
import { JSX } from "react/jsx-runtime";
const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="9.5"
    height="4.5"
    viewBox="0 0 11 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-[7px] h-[3px] md:w-[9.5px] md:h-[4.5px] ${props.className || ""}`}
    {...props}
  >
    <path
      d="M0.600098 0.599976L5.6001 5.09998L10.1001 0.599976"
      stroke="#1F2A37"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
  </svg>
);
export default SVGComponent;
